import type { AgentVisibility } from "@/models/aiAgents";

export const getSelectedDealPath = (id: string | undefined) => {
  if (!id) {
    return "";
  }

  const origin = location?.origin || "";
  const path = `/deals/${id}/progress`;

  return `${origin}${path}`;
};

export const getUpdatedVisibilities = (
  visibilities: AgentVisibility[],
  updatedVisibility: AgentVisibility
) => {
  const oldVisibility = visibilities.find(
    ({ agent_id, applies_to_type, feature }) =>
      agent_id === updatedVisibility.agent_id &&
      applies_to_type === updatedVisibility.applies_to_type &&
      feature === updatedVisibility.feature
  );

  if (!oldVisibility) {
    return [...visibilities, updatedVisibility];
  }

  return visibilities.map((visibility) => {
    if (
      visibility.agent_id === updatedVisibility.agent_id &&
      visibility.applies_to_type === updatedVisibility.applies_to_type &&
      visibility.feature === updatedVisibility.feature
    ) {
      return updatedVisibility;
    }

    return visibility;
  });
};

export const AGENT_SEARCH_PREFIX = "@";
export const PROMPT_DEAL_PREFIX = "/";
